<template>
  <div class="lecturer-detail-container" v-loading="loading">
    <!-- 无选中讲师时的提示 -->
    <div class="no-lecturer" v-if="!lecturer && !loading">
      <i class="el-icon-user"></i>
      <p>请选择一位讲师</p>
    </div>

    <template v-else-if="lecturer">
      <!-- 基本信息区域 -->
      <div class="info-section">
        <div class="lecturer-card">
          <!-- 头像 -->
          <div class="lecturer-avatar">
            <el-image v-if="lecturer.teacherHeader" :src="lecturer.teacherHeader" fit="cover" style="width: 100%; height: 100%; border-radius: 100%;" />
            <span v-else class="avatar-text">{{ getAvatarText(lecturer.teacherName) }}</span>
          </div>

          <!-- 基本信息 -->
          <div class="basic-info">
            <div class="name-row">
              <span class="lecturer-name">{{ lecturer.teacherName }}</span>
              <el-tag size="small" :type="getTypeTagType(lecturer.teacherType)">
                {{ getTypeLabel(lecturer.teacherType) }}
              </el-tag>
            </div>
            <div class="position-row">
              <i class="el-icon-briefcase"></i>
              <span>{{ lecturer.teacherPosition || '暂无职位' }}</span>
            </div>
            <div class="lecturer-code" v-if="lecturer.teacherNumber">
              <span class="code-label">讲师编码：</span>
              <span class="code-value">{{ lecturer.teacherNumber }}</span>
            </div>
          </div>

          <!-- 右侧操作按钮 -->
          <div class="action-buttons">
            <el-button
              class="action-btn"
              :class="currentView === 'summary' ? 'summary-btn active' : 'summary-btn'"
              @click="switchView('summary')"
            >
              <i class="el-icon-document"></i>
              讲师概述
            </el-button>
            <el-button
              class="action-btn"
              :class="currentView === 'schedule' ? 'schedule-btn active' : 'schedule-btn'"
              @click="switchView('schedule')"
            >
              <i class="el-icon-tickets"></i>
              课程安排
            </el-button>
            <!-- <el-button class="action-btn outline-btn" @click="handleGenerateOutline">
              <i class="el-icon-tickets"></i>
              生成课单
            </el-button>
            <el-button class="action-btn resume-btn" @click="handleGenerateResume">
              <i class="el-icon-notebook-2"></i>
              生成简历
            </el-button> -->
          </div>
        </div>

        <!-- 课程安排 -->
        <div v-show="currentView === 'schedule'" class="lecturer-schedule-wrapper" >
          <LecturerSchedule
            :key="currentView"
            :teacherId="lecturer ? lecturer.teacherId : null"
            :lecturerName="lecturer ? lecturer.teacherName : ''"
          />
        </div>

        <!-- 讲师简介 -->
        <div v-show="currentView === 'summary'" class="introduction-box">
          <div class="section-title">
            <i class="el-icon-notebook-2"></i>
            <span>讲师简介</span>
          </div>
          <div class="introduction-content">
            {{ lecturer.teacherIntroduction || '暂无简介' }}
          </div>
        </div>
      </div>

      <!-- 详细信息区域 -->
      <div v-show="currentView === 'summary'" class="detail-section">
        <!-- 基本信息卡片 -->
        <div class="detail-card">
          <div class="card-header">
            <span class="card-title">基本信息</span>
          </div>
          <div class="card-content">
            <el-row :gutter="0" class="info-row">
              <el-col :span="6" class="info-item">
                <div class="info-label">讲师姓名</div>
                <div class="info-value">{{ lecturer.teacherName }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">讲师编码</div>
                <div class="info-value">{{ lecturer.teacherNumber || '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">讲师类型</div>
                <div class="info-value">
                  <el-tag size="small" :type="getTypeTagType(lecturer.teacherType)">
                    {{ getTypeLabel(lecturer.teacherType) }}
                  </el-tag>
                </div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">职位头衔</div>
                <div class="info-value">{{ lecturer.teacherPosition || '-' }}</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="info-row">
              <el-col :span="6" class="info-item">
                <div class="info-label">讲师分类</div>
                <div class="info-value">{{ lecturer.atcNames || '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">讲师标签</div>
                <div class="info-value">{{ lecturer.atlNames || '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">身份证号</div>
                <div class="info-value">{{ lecturer.teacherIdcard || '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">讲师负责人</div>
                <div class="info-value">{{ lecturer.auName || '-' }}</div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 联系信息卡片 -->
        <div class="detail-card">
          <div class="card-header">
            <span class="card-title">联系信息</span>
          </div>
          <div class="card-content">
            <el-row :gutter="0" class="info-row">
              <el-col :span="6" class="info-item">
                <div class="info-label">联系电话</div>
                <div class="info-value">{{ lecturer.contactPhone || '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">联系邮箱</div>
                <div class="info-value">{{ lecturer.contactEmail || '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">联系微信</div>
                <div class="info-value">{{ lecturer.contactWechat || '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">常驻地</div>
                <div class="info-value">{{ lecturer.teacherAddress || '-' }}</div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 价格信息卡片 -->
        <div class="detail-card">
          <div class="card-header">
            <span class="card-title">价格信息</span>
          </div>
          <div class="card-content">
            <el-row :gutter="0" class="info-row">
              <el-col :span="6" class="info-item">
                <div class="info-label">讲师价格</div>
                <div class="info-value price">{{ lecturer.teacherPrice ? `¥${lecturer.teacherPrice}` : '-' }}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div class="info-label">价格区间</div>
                <div class="info-value">{{ lecturer.teacherPriceRange || '-' }}</div>
              </el-col>
              <el-col :span="12" class="info-item">
                <div class="info-label">擅长课程</div>
                <div class="info-value">{{ lecturer.teacherCourseTalent || '-' }}</div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 简介附件卡片 -->
        <div class="detail-card" v-if="lecturer.teacherIntroductionFileOne || lecturer.teacherIntroductionFileTwo">
          <div class="card-header">
            <span class="card-title">简介附件</span>
          </div>
          <div class="card-content">
            <el-row :gutter="0" class="info-row" v-if="lecturer.teacherIntroductionFileOne">
              <el-col :span="24" class="info-item">
                <div class="info-label">简介附件1</div>
                <a :href="lecturer.teacherIntroductionFileOne" target="_blank" class="file-link">
                  <i class="el-icon-paperclip"></i>
                  点击查看附件
                </a>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="info-row" v-if="lecturer.teacherIntroductionFileTwo">
              <el-col :span="24" class="info-item">
                <div class="info-label">简介附件2</div>
                <a :href="lecturer.teacherIntroductionFileTwo" target="_blank" class="file-link">
                  <i class="el-icon-paperclip"></i>
                  点击查看附件
                </a>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 其他信息卡片 -->
        <div class="detail-card">
          <div class="card-header">
            <span class="card-title">其他信息</span>
          </div>
          <div class="card-content">
            <el-row :gutter="0" class="info-row">
              <el-col :span="12" class="info-item">
                <div class="info-label">创建时间</div>
                <div class="info-value">{{ lecturer.createtime || '-' }}</div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 讲师协议卡片 -->
        <div class="detail-card" v-if="lecturer.ajTeacherAgreementList && lecturer.ajTeacherAgreementList.length > 0">
          <div class="card-header">
            <span class="card-title">讲师协议</span>
          </div>
          <div class="card-content">
            <div class="list-section" v-for="(item, index) in lecturer.ajTeacherAgreementList" :key="index">
              <div class="list-row">
                <div class="list-label">
                  <i class="el-icon-document"></i>
                  <span>{{ item.ataTitle || '协议' + (index + 1) }}</span>
                </div>
                <div class="list-actions">
                  <template v-if="item.ataPath">
                    <template v-for="(fileUrl, idx) in parseFilePaths(item.ataPath)">
                      <a v-if="fileUrl" :key="idx" :href="fileUrl" target="_blank" class="file-link">
                        <i class="el-icon-download"></i>下载协议{{ idx + 1 }}
                      </a>
                    </template>
                  </template>
                  <span class="list-date">{{ item.ataDate || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 试讲视频卡片 -->
        <div class="detail-card" v-if="lecturer.ajTeacherCourseTrailList && lecturer.ajTeacherCourseTrailList.length > 0">
          <div class="card-header">
            <span class="card-title">试讲视频</span>
          </div>
          <div class="card-content">
            <div class="list-section" v-for="(item, index) in lecturer.ajTeacherCourseTrailList" :key="index">
              <div class="list-row">
                <div class="list-label">
                  <i class="el-icon-video-camera" style="color: #f59e0b;"></i>
                  <span>{{ item.atctTitle || '视频' + (index + 1) }}</span>
                </div>
                <div class="list-actions">
                  <template v-if="item.atctPath">
                    <template v-for="(videoUrl, idx) in parseFilePaths(item.atctPath)">
                      <a v-if="videoUrl" :key="idx" :href="videoUrl" target="_blank" class="file-link file-link-primary">
                        <i class="el-icon-video-play"></i>观看视频{{ idx + 1 }}
                      </a>
                    </template>
                  </template>
                  <span class="list-date">{{ item.atctDate || '-' }}</span>
                </div>
              </div>
              <div class="list-desc" v-if="item.atctDes">
                {{ item.atctDes }}
              </div>
            </div>
          </div>
        </div>

        <!-- 授课记录卡片 -->
        <div class="detail-card" v-if="lecturer.ajTeacherCourseHistoryList && lecturer.ajTeacherCourseHistoryList.length > 0">
          <div class="card-header">
            <span class="card-title">授课记录</span>
          </div>
          <div class="card-content">
            <div class="list-section" v-for="(item, index) in lecturer.ajTeacherCourseHistoryList" :key="index">
              <div class="list-row">
                <div class="list-label">
                  <i class="el-icon-reading" style="color: #10b981;"></i>
                  <span>{{ item.atchTitle || '授课主题' }}</span>
                </div>
                <div class="list-actions">
                  <el-tag type="success" size="small" effect="plain">
                    <i class="el-icon-star-on"></i> {{ item.atchStar || 0 }}分
                  </el-tag>
                  <span class="list-date">{{ item.atchDate || '-' }}</span>
                </div>
              </div>
              <div class="list-desc">
                {{ item.atchUnit || '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- 课程信息 -->
        <div class="detail-card">
          <div class="card-header">
            <span class="card-title">课程信息</span>
            <span class="card-subtitle">该讲师暂无课程</span>
          </div>
          <div class="card-content">
            <div class="empty-courses">
              <i class="el-icon-document"></i>
              <p>暂无课程信息</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getAjTeacherDetails } from "../../api/api";
import LecturerSchedule from "./LecturerSchedule.vue";

export default {
  name: "LecturerDetail",
  components: {
    LecturerSchedule
  },
  props: {
    teacherId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      lecturer: null,
      loading: false,
      currentView: 'summary' // 'summary' 讲师概述, 'schedule' 课程安排
    };
  },
  watch: {
    teacherId: {
      handler(newVal) {
        if (newVal) {
          this.loadLecturerDetail(newVal);
        } else {
          this.lecturer = null;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取头像文字（姓名后2个字）
    getAvatarText(name) {
      if (!name) return "老师";
      const len = name.length;
      if (len <= 2) return name;
      return name.substring(len - 2);
    },

    // 加载讲师详情
    async loadLecturerDetail(id) {
      if (!id) return;

      this.loading = true;
      try {
        const res = await getAjTeacherDetails({ teacherId: id });
        if (res.status === 200) {
          this.lecturer = res.data || null;
        } else {
          this.$message.error(res.msg || '获取讲师详情失败');
        }
      } catch (error) {
        console.error("获取讲师详情失败:", error);
        this.$message.error('获取讲师详情失败');
      } finally {
        this.loading = false;
      }
    },

    // 获取类型标签颜色
    getTypeTagType(type) {
      const typeMap = {
        1: '', // 内部 - 蓝色
        2: 'success', // 外部 - 绿色
        3: 'warning' // 独家 - 橙色
      };
      return typeMap[type] || '';
    },

    // 获取类型标签文本
    getTypeLabel(type) {
      const typeMap = {
        1: '内部',
        2: '外部',
        3: '独家'
      };
      return typeMap[type] || '未知';
    },

    // 解析文件地址数组
    parseFilePaths(pathStr) {
      if (!pathStr) return [];
      try {
        const parsed = JSON.parse(pathStr);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        return [];
      }
    },

    // 切换视图
    switchView(view) {
      this.currentView = view;
      // 发送事件通知子组件刷新数据
      this.$nextTick(() => {
        // 滚动到内容区域
        const contentEl = view === 'schedule'
          ? document.querySelector('.lecturer-schedule-wrapper')
          : document.querySelector('.lecturer-detail-container');
        if (contentEl) {
          contentEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },

    // 编辑资料
    handleEdit() {
      this.$message.info("编辑资料功能开发中...");
    },

    // 分配课程
    handleAssignCourse() {
      this.switchView('schedule');
    },

    // 生成课单
    handleGenerateOutline() {
      this.$message.info("生成课单功能开发中...");
    },

    // 生成简历
    handleGenerateResume() {
      this.$message.info("生成简历功能开发中...");
    }
  }
};
</script>

<style scoped>
.lecturer-detail-container {
  height: 100%;
  overflow-y: auto;
  background: #f9fafb;
}

.no-lecturer {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}

.no-lecturer i {
  font-size: 56px;
  margin-bottom: 12px;
  color: #d1d5db;
}

.no-lecturer p {
  font-size: 14px;
  color: #9ca3af;
}

/* 基本信息区域 */
.info-section {
  margin-bottom: 0;
  padding: 16px;
}

.lecturer-card {
  display: flex;
  align-items: center;
  padding: 24px;
  background: linear-gradient(180deg, #fff 0%, #fafbfc 100%);
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  position: relative;
  overflow: hidden;
}

.lecturer-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #8b5cf6, #764ba2);
  opacity: 0.9;
}

/* 头像样式 */
.lecturer-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  border: 4px solid #fff;
}

.avatar-text {
  color: #fff;
  font-size: 20px;
  font-weight: 500;
}

.basic-info {
  flex: 1;
  min-width: 0;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.lecturer-name {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.position-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #64748b;
  margin-top: 6px;
}

.position-row i {
  color: #667eea;
}

.lecturer-code {
  margin-top: 10px;
  font-size: 13px;
  color: #909399;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
  border-radius: 20px;
}

.code-label {
  color: #909399;
}

.code-value {
  color: #667eea;
  font-weight: 600;
}

.action-buttons {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.action-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.action-btn:hover::before {
  left: 100%;
}

.action-btn i {
  font-size: 14px;
}

.edit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.35);
}

.edit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.45);
}

.summary-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.35);
}

.summary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.45);
}

.summary-btn.active {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  box-shadow: 0 4px 14px rgba(118, 75, 162, 0.45);
  transform: translateY(-2px);
}

.schedule-btn {
  background: linear-gradient(135deg, #67c23a 0%, #529e2c 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(103, 194, 58, 0.35);
}

.schedule-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(103, 194, 58, 0.45);
}

.schedule-btn.active {
  background: linear-gradient(135deg, #529e2c 0%, #67c23a 100%);
  box-shadow: 0 4px 14px rgba(82, 158, 44, 0.45);
  transform: translateY(-2px);
}

.outline-btn {
  background: linear-gradient(135deg, #e6a23c 0%, #d4912c 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(230, 162, 60, 0.35);
}

.outline-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(230, 162, 60, 0.45);
}

.resume-btn {
  background: linear-gradient(135deg, #909399 0%, #6b7280 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(144, 147, 153, 0.35);
}

.resume-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(144, 147, 153, 0.45);
}


/* 讲师简介 */
.introduction-box {
  padding: 16px 20px;
  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
  position: relative;
  margin: 10px 0 16px;
  border-radius: 12px;
}

.introduction-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.3), transparent);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 12px;
}

.section-title i {
  color: #667eea;
}

.introduction-content {
  font-size: 14px;
  color: #5a6474;
  line-height: 1.8;
  padding: 14px 18px;
  background: linear-gradient(135deg, #f8f9fc 0%, #fff 100%);
  border-radius: 10px;
  border-left: 3px solid #667eea;
}

/* 课程安排包装器 */
.lecturer-schedule-wrapper {
  padding: 0 16px;
  margin-top: 20px;
}

/* 详细信息区域 */
.detail-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px;
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02), 0 4px 12px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: all 0.25s ease;
}

.detail-card:hover {
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.08), 0 8px 24px rgba(0, 0, 0, 0.05);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 100%);
  position: relative;
}

.card-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 2px;
  background: linear-gradient(90deg, #667eea, rgba(102, 126, 234, 0));
  border-radius: 1px;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-title::before {
  content: '';
  width: 3px;
  height: 16px;
  background: linear-gradient(180deg, #667eea, #8b5cf6);
  border-radius: 2px;
}

.card-subtitle {
  font-size: 12px;
  color: #9ca3af;
}

.card-content {
  padding: 16px 20px;
}

.info-row {
  margin-bottom: 12px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-item {
  padding-right: 20px;
}

.info-label {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  letter-spacing: 0.5px;
}

.info-label::before {
  content: '';
  width: 4px;
  height: 4px;
  background: #d1d5db;
  border-radius: 50%;
}

.info-value {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px 12px;
  background: #f9fafb;
  border-radius: 6px;
  border: none;
}

.info-value.price {
  color: #059669;
  font-weight: 600;
  font-size: 15px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border: none;
}

.file-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #667eea;
  text-decoration: none;
  font-size: 13px;
  padding: 6px 12px;
  background: transparent;
  border-radius: 6px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.file-link:hover {
  color: #764ba2;
  background: linear-gradient(135deg, #e8eeff 0%, #ddd6fe 100%);
  border-color: rgba(102, 126, 234, 0.3);
  transform: translateX(4px);
}

/* 空课程状态 */
.empty-courses {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  color: #9ca3af;
  background: #fafbfc;
  border-radius: 10px;
  margin: 12px 0;
}

.empty-courses i {
  font-size: 48px;
  margin-bottom: 12px;
  color: #d1d5db;
}

.empty-courses p {
  font-size: 13px;
  color: #9ca3af;
}

/* 列表样式 */
.list-section {
  padding: 12px 0;
  border-bottom: 1px dashed #e5e7eb;
}

.list-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.list-section:first-child {
  padding-top: 0;
}

.list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.list-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.list-label i {
  color: #667eea;
}

.list-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.list-date {
  font-size: 12px;
  color: #9ca3af;
}

.list-desc {
  font-size: 12px;
  color: #6b7280;
  padding-left: 24px;
  margin-top: 4px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .lecturer-card {
    flex-wrap: wrap;
  }

  .action-buttons {
    width: 100%;
    margin-top: 16px;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .action-buttons {
    flex-wrap: wrap;
  }

  .action-btn {
    flex: 1;
    justify-content: center;
  }
}
</style>
